import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header';
import { FooterComponent } from './components/footer/footer';
import { LoginComponent } from './components/login/login';
import { CampaignsComponent } from './components/campaigns/campaigns';
import { AuthenticationService } from "./_services/authentication.service";
import { HttpClientModule } from '@angular/common/http';
import { AlertComponent} from "./_directives/alert.component";
import { AlertService } from "./_services/alert.service";
import { ErrorService } from "./_services/error.service";
import { SettingsService } from "./_services/settings.service";
import { CampaignPipe, RepCampaignPipe, RepCampaignIdPipe,RepCampaignDevPipe,RepCampaignAccPipe,RepCampaignJoinPipe } from "./pipes/campaign.pipe";
import { InvoicingComponent } from "./components/invoicing/invoicing";
import { CustomersComponent } from "./components/customers/customers";
import { CustomerPipe } from "./pipes/customer.pipe";
import { ReportsService } from "./_services/reports.service";
import { ReportsComponent } from "./components/reports/reports";
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ItemsComponent } from "./components/items/items";



@NgModule({
  imports: [BrowserModule, HttpClientModule, FormsModule, ChartsModule],
  declarations: [AppComponent, AlertComponent, HeaderComponent, FooterComponent, LoginComponent, CampaignsComponent, CampaignPipe, CustomerPipe, RepCampaignPipe, RepCampaignIdPipe, RepCampaignDevPipe, RepCampaignAccPipe, RepCampaignJoinPipe, InvoicingComponent, CustomersComponent, ReportsComponent,ItemsComponent],
  providers: [AuthenticationService, AlertService, ErrorService, SettingsService,ReportsService],
  bootstrap:    [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/app.module.ts